import container from './ArtistNotifications.container' 

export default container